<div class="tag-container table-tags-container select-bottom" [ngClass]="lowerBoundClass">
  <form [formGroup]="tagForm">
    <form-factory [formGroup]="tagForm" [model]="tagInput" (onInput)="onAddTags($event)" (onBlur)="textboxBlur()" (onFocus)="textboxFocus()" (onChange)="onChange()" (keyup)="onKeyUp($event)"></form-factory>
    <app-color-palette [isCreateTagTemplateVisible]="isCreateTagTemplateVisible" [hasTags]="value" [selectedTagAction]="tagActionType"
                       (selectedColor)="onSelectedColor($event)" [hastextValue]="tagName" [lowerBoundClass]="lowerBoundClass"></app-color-palette>
  </form>
</div>

